import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importJobsRoot = () => import(/* webpackChunkName: "jobs-root" */ './containers/JobsRootContainer');


const JobsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importJobsRoot}
      path={`${match.url}/:tabName?`}
    />
  </LoginRequiredContainer>
);

JobsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default JobsRoutes;
export { JobsRoutes };
